import { useTranslation } from 'react-i18next';

import { FaIcon } from '../icons/FaIcon';
import { LoadingRetryButton } from './LoadingRetryButton';

export type LoadingFailedBoxProps = {
  onRetry?: () => void | Promise<void>;
};

export function LoadingFailedBox({ onRetry }: LoadingFailedBoxProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-warning-subtle border border-1 border-warning-subtle border-dashed px-3 py-5 text-warning rounded-1 text-center">
      <FaIcon icon="fal fa-warning" /> {t('Loading_GeneralLoadingFailedMessage')}
      {onRetry != null && (
        <div className="mt-3">
          <LoadingRetryButton onRetry={onRetry} />
        </div>
      )}
    </div>
  );
}
